module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./StoreWalletView.js"));
	}, "StoreWalletView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StoreWalletView!./src/pages/Store/Wallet/StoreWallet/StoreWalletView.js
// module id = 1212
// module chunks = 431